















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Supporter extends Vue {
  @Prop() public image!: string;
  @Prop() public name!: string;
  @Prop() public description!: string;
}
